var ARROW_WIDTH = 5;
var ARROW_SPACER = ARROW_WIDTH + 2;
var ARROW_SHIFT = 8;

export { ARROW_SHIFT, ARROW_SPACER, ARROW_WIDTH };
//# sourceMappingURL=Tooltip.constants.js.map
